import { useState, useEffect } from 'react';

const DB_NAME = 'persistentStateDB';
const STORE_NAME = 'stateStore';

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => {
      request.result.createObjectStore(STORE_NAME);
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

function idbGet(key: string): Promise<any> {
  return openDB().then((db) => {
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const store = tx.objectStore(STORE_NAME);
      const req = store.get(key);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  });
}

function idbSet(key: string, value: any): Promise<void> {
  return openDB().then((db) => {
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const req = store.put(value, key);
      req.onsuccess = () => resolve();
      req.onerror = () => reject(req.error);
    });
  });
}

export function useIndexedDBState<T>(
  key: string,
  initialValue: T,
): [T, React.Dispatch<React.SetStateAction<T>>, boolean] {
  const [state, setState] = useState<T>(initialValue);
  const [hasBeenRead, setHasBeenRead] = useState<boolean>(false);

  useEffect(() => {
    idbGet(key).then((storedValue) => {
      if (storedValue !== undefined) {
        setState(storedValue);
        setHasBeenRead(true);
      } else {
        setState(initialValue);
      }
    });
  }, [key]);

  useEffect(() => {
    idbSet(key, state).catch(console.error);
  }, [key, state]);

  return [state, setState, hasBeenRead];
}
